import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

export function exportarFacturaIndividualAExcel(factura) {
  // Hoja 1: Datos de la factura
  const datosFactura = [{
    'Nº Factura': `${factura.serie}-${factura.numero}`,
    'Fecha': new Date(factura.fecha_emision).toLocaleDateString('es-ES'),
    'Cliente': factura.cliente_nombre,
    'CIF': factura.cliente_cif || '',
    'Periodo Inicio': new Date(factura.periodo_inicio).toLocaleDateString('es-ES'),
    'Periodo Fin': new Date(factura.periodo_fin).toLocaleDateString('es-ES'),
    'Base': factura.base_imponible.toFixed(2),
    'IVA': factura.iva.toFixed(2),
    'RE': factura.recargo_equivalencia?.toFixed(2) || '0.00',
    'Total': factura.total.toFixed(2)
  }]
  
  // Hoja 2: Líneas de la factura
  const lineas = (factura.lineas || []).map(l => ({
    'Concepto': l.concepto,
    'Cantidad': l.cantidad,
    'Precio Unitario': l.precio_unit.toFixed(2),
    'Base': l.base.toFixed(2),
    'IVA %': l.iva_pct,
    'Total': l.total.toFixed(2)
  }))
  
  // Crear libro
  const wb = XLSX.utils.book_new()
  
  // Añadir hojas
  const wsFactura = XLSX.utils.json_to_sheet(datosFactura)
  const wsLineas = XLSX.utils.json_to_sheet(lineas)
  
  XLSX.utils.book_append_sheet(wb, wsFactura, 'Factura')
  XLSX.utils.book_append_sheet(wb, wsLineas, 'Líneas')
  
  // Exportar
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
  const blob = new Blob([wbout], { type: 'application/octet-stream' })
  
  saveAs(blob, `factura-${factura.serie}-${factura.numero}.xlsx`)
}

export function exportarFacturasAExcel(facturas) {
  const datos = facturas.map(f => ({
    'Nº Factura': `${f.serie}-${f.numero}`,
    'Fecha': new Date(f.fecha_emision).toLocaleDateString('es-ES'),
    'Cliente': f.cliente_nombre,
    'CIF': f.cliente_cif || '',
    'Periodo': `${new Date(f.periodo_inicio).toLocaleDateString('es-ES')} - ${new Date(f.periodo_fin).toLocaleDateString('es-ES')}`,
    'Base': f.base_imponible.toFixed(2),
    'IVA': f.iva.toFixed(2),
    'RE': f.recargo_equivalencia?.toFixed(2) || '0.00',
    'Total': f.total.toFixed(2),
    'Estado VeriFactu': f.estado_verifactu,
    'Enviada Cliente': f.enviada_cliente ? 'Sí' : 'No',
    'Enviada Gestoría': f.enviada_gestoria ? 'Sí' : 'No'
  }))
  
  const ws = XLSX.utils.json_to_sheet(datos)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Facturas')
  
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
  const blob = new Blob([wbout], { type: 'application/octet-stream' })
  
  const fecha = new Date().toISOString().slice(0, 10)
  saveAs(blob, `facturas-${fecha}.xlsx`)
}